<template>
	<div>
		<div class="header--section container compact-padding">
			<h1 class="heading--xl text-uppercase header--section__heading">
				Please confirm you really want to unsubscribe.
			</h1>
			<p>
				We are sorry to see you go. If you change your mind, you can
				always subscribe again.
			</p>
			<div v-if="error">
				<p style="color: red;">{{ error }}</p>
			</div>
			<BasicButton
				v-if="!isDeleted"
				style="margin-top: 10px;"
				type="black"
				@click="submitUnsubscribe"
				><span class="unsub">YES, UNSUBSCRIBE ME</span></BasicButton
			>
			<div v-if="isDeleted">
				<p class="text">
					You have successfully unsubscribed from our job offers.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import Hero from "../components/common/HerroConstructor";
import BasicButton from "../components/BasicButton";
// import UnsolicitedForm from "../components/applicationPageComponents/UnsolicitedForm";
// import ApplicationForm from "../components/applicationPageComponents/ApplicationForm";
import SubscribeForm from "../components/applicationPageComponents/SubscribeForm";
import { postUnsubscribe } from "../services/subscribe";

export default {
	name: "subscribe-component",
	components: {
		// UnsolicitedForm,
		Hero,
		BasicButton,
		SubscribeForm
		// ApplicationForm
	},
	data() {
		return {
			isDeleted: false,
			error: ""
		};
	},
	mounted() {
		const scrollTopButton = document.getElementsByClassName(
			"top-button-container"
		);
		console.log(scrollTopButton.item(0).remove());
	},
	metaInfo() {
		return {
			title: "Open job application",
			htmlAttrs: {
				lang: "en",
				metaInfo: {
					meta: [
						{ charset: "utf-8" },
						{ name: "og:title", content: "Open application" },
						{
							name: "description",
							content: "Bohemia Interactive open application page"
						},
						{
							name: "og:image",
							content: "Bohemia Interactive position page"
						},
						{ name: "og:type", content: "Open application page" }
					]
				}
			}
		};
	},
	methods: {
		async submitUnsubscribe() {
			const uid = this.$route.query.uid;
			const email = this.$route.params.slug;
			try {
				const body = {
					uid: uid,
					email: email
				};
				await postUnsubscribe(body);
				this.isDeleted = true;
			} catch (err) {
				this.error =
					"Unsubscription failed. You are already unsubscribed or the link is invalid.";
				console.log(err);
			}
		}
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../assets/scss/globals";

#form {
	padding-bottom: 40px;
}

.header--section {
	padding: 5em;
	padding-bottom: 18em;
	@media (max-width: $compact) {
		padding: 3em;
	}
}

.unsub {
	font-size: 16px;
	font-weight: 700;
}

.header--section__heading {
	margin-top: 62px;
	margin-bottom: 62px;
	@media (max-width: $compact) {
		margin-top: 10px;
		margin-bottom: 20px;
	}
}

.main-heading {
	text-transform: uppercase;
	font-size: 36px;
	font-weight: 800;
	letter-spacing: 0.72px;
	font-family: Montserrat, sans-serif;
	margin-top: 60px;
	margin-bottom: 40px;
}

.paragraph {
	font-family: "Inter UI", sans-serif;
	font-size: 16px;
	letter-spacing: 0.02px;
	line-height: 28px;
	font-weight: 400;
}

.sub-header {
	font-size: 35px;
	font-family: "Montserrat", sans-serif;
	margin-bottom: 45px;
	margin-top: 75px;
	font-weight: 300;
	letter-spacing: 0.19px;
	word-wrap: break-word;

	@media (max-width: $tablet) {
		font-size: 22px;
	}
}

.text {
	margin-top: 45px;
	word-wrap: break-word;
}

.button-wrapper {
	@media (max-width: $compact) {
		display: flex;
		justify-content: center;
		align-self: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/UnsubscribePage.vue